import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { authStore } from '@/stores/auth'
import axios from 'axios'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsWidget',
  setup(__props) {

const auth = authStore()
const router = useRouter()
const screenWidth = computed(() => window.innerWidth)

const baseColumns = [
  {
    title: 'Onderwerp',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: 'Object',
    dataIndex: 'building',
    key: 'building'
  },
  {
    title: 'Datum',
    dataIndex: 'published_at',
    key: 'published_at'
  },
  {
    title: 'Actie\'s',
    dataIndex: 'actions',
    key: 'actions'
  }
]

const news = ref([])
const loading = ref(false)

const columns = computed(() => {
  const columns = baseColumns
  if (!auth.multipleObjects) {
    columns.splice(1, 1)
  }

  return columns
})

onMounted(() => {
  getNews()
})

function getNews () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/news?sort=-publish_at&limit=100').then((res) => {
    news.value = res.data.data
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Nieuwsberichten",
    bordered: false,
    loading: loading.value
  }, {
    default: _withCtx(() => [
      (_unref(screenWidth) >= 768)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  (news.value.length)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 0,
                        dataSource: news.value,
                        columns: _unref(columns),
                        pagination: { pageSize: 5 },
                        scroll: { x: true }
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'building' && record.full_buildings.length)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(record.full_buildings, (building) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: building.id
                                }, [
                                  _createTextVNode(_toDisplayString(building.address) + ", " + _toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1),
                                  _hoisted_1
                                ]))
                              }), 128))
                            : _createCommentVNode("", true),
                          (column.key === 'published_at')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(new Date(record.published_at).toLocaleDateString('nl-NL')), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.key === 'actions')
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 2,
                                type: "link",
                                size: "small",
                                onClick: ($event: any) => (_unref(router).push({ name: 'NewsShow', params: { newsId: record.id.toString() } }))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Bekijken")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["dataSource", "columns"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_2, "Er zijn geen berichten van uw verhuurder."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  (news.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news.value, (newsItem, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: newsItem.id
                          }, [
                            _createElementVNode("i", null, _toDisplayString(new Date(newsItem.published_at).toLocaleDateString('nl-NL')), 1),
                            _hoisted_4,
                            _createElementVNode("b", null, _toDisplayString(newsItem.title), 1),
                            _hoisted_5,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newsItem.full_buildings, (building) => {
                              return (_openBlock(), _createElementBlock("span", {
                                key: building.id
                              }, [
                                _createTextVNode(_toDisplayString(building.address) + ", " + _toDisplayString(building.zipcode) + " " + _toDisplayString(building.city), 1),
                                _hoisted_6
                              ]))
                            }), 128)),
                            _createVNode(_component_a_button, {
                              type: "link",
                              size: "small",
                              style: {"padding":"0","margin-top":"8px"},
                              onClick: ($event: any) => (_unref(router).push({ name: 'NewsShow', params: { newsId: newsItem.id.toString() } }))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Bekijken")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (index + 1 !== news.value.length)
                              ? (_openBlock(), _createBlock(_component_a_divider, {
                                  key: 0,
                                  style: {"margin":"16px 0"}
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, "Er zijn geen vragen."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})